import { API_BASE } from "./bookingLinks";

export async function fetchPublicContent(collectionName, { id, signal } = {}) {
	const url = new URL(`${API_BASE}/notify-booking`);
	url.searchParams.set("publicContent", collectionName);
	if (id) url.searchParams.set("id", id);

	const response = await fetch(url.toString(), { signal });
	const result = await response.json();
	if (!response.ok) {
		throw new Error(result.message || "Could not load public content.");
	}

	if (id) {
		if (!result.item || typeof result.item !== "object") {
			throw new Error("The public content response was invalid.");
		}
		return result.item;
	}
	if (!Array.isArray(result.items)) {
		throw new Error("The public content response was invalid.");
	}
	return result.items;
}
